<template>
  <AppModal :mode="mode" title="Details" @close="close" width="max-w-3xl">
    <template #body>
      <div
        class="overflow-hidden rounded-lg border"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <div
          class="divide-y"
          :class="[mode === 'dark' ? 'divide-dark-border' : 'divide-border-10']"
        >
          <div
            v-for="(item, key) in powerspecDetails"
            :key="key"
            class="flex justify-between"
          >
            <div
              class="flex w-[130px] items-center border-r bg-opacity-50 p-3"
              :class="[
                mode === 'dark'
                  ? 'border-dark-border bg-dark-border'
                  : 'border-border-10 bg-black-10',
              ]"
            >
              <span
                class="text-[14px] font-semibold"
                :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
                >{{ item.name }}</span
              >
            </div>
            <div class="flex-1 p-3">
              <span
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
                >{{ item.value ? item.value : "-" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import AppModal from "@C/Common/AppModal.vue";

export default {
  name: "EquipSpecSheet",
  props: {
    powerspec: {
      type: Object,
      default: null,
    },
    mode: String,
  },
  components: {
    AppModal,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    powerspecDetails() {
      return [
        {
          name: "Description",
          value: this.powerspec?.prod_description,
        },
        {
          name: "Product Note",
          value: this.powerspec?.product_note,
        },
        {
          name: "Manufacturer",
          value: this.powerspec?.manufacturer_name,
        },
        {
          name: "Prod ID",
          value: this.powerspec?.equipment_id,
        },
        {
          name: "MSRP",
          value: this.powerspec?.msrp,
        },
        {
          name: "Status",
          value: this.powerspec?.item_status_description,
        },
        {
          name: "Auth Req",
          value: this.powerspec?.prod_authorization_req_ind ? "Yes" : "No",
        },
        {
          name: "Licensing Req",
          value: this.powerspec?.licensing_ind ? "Yes" : "No",
        },
        {
          name: "Effective Date",
          value: this.powerspec?.prod_effective_date,
        },
        {
          name: "Size",
          value: this.powerspec?.prod_length,
        },
        {
          name: "Weight",
          value: this.powerspec?.prod_weight,
        },
        {
          name: "UPC",
          value: this.powerspec?.prod_upc,
        },
        {
          name: "Drop ship",
          value: this.powerspec?.vendor_drop_ship_ind ? "Yes" : "No",
        },
      ];
    },
  },
};
</script>
